




























import { IVehicle } from "@/models/vehicle.entity";
import { mixins } from "vue-class-component";
import { Component, Prop, Vue } from "vue-property-decorator";
import SideCard from "../utility/SideCard.vue";
import { VehicleContractTypeEnum } from "@/lib/enum/vehicle-contract-type.enum";
import { ISignDocument } from "@/models/sign-document.entity";
import ContractCard from "./ContractCard.vue";
import { VehicleContractType } from "@/models/types/vehicle-contract-type";

@Component({
  components: { SideCard, ContractCard },
  filters: {}
})
export default class VehicleContractSideCard extends mixins(Vue) {
  @Prop()
  value!: VehicleContractType;

  @Prop()
  loading!: boolean;

  @Prop()
  partnerId!: string;

  @Prop()
  vehicle?: IVehicle;

  @Prop()
  vehicleId!: string;

  @Prop({ default: () => [] })
  documentSuggestions!: ISignDocument[];

  @Prop({ default: false })
  loadingDocumentSuggestions!: boolean;

  readonly ContractTypeEnum = VehicleContractTypeEnum;

  height = document.documentElement.clientHeight;

  get fullscreenBreakpoint() {
    return this.$vuetify.breakpoint.width < 1500;
  }

  onResize() {
    this.height = document.documentElement.clientHeight;
  }
}
